var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.66675C5.40829 1.66675 1.66663 5.40841 1.66663 10.0001C1.66663 14.5917 5.40829 18.3334 9.99996 18.3334C14.5916 18.3334 18.3333 14.5917 18.3333 10.0001C18.3333 5.40841 14.5916 1.66675 9.99996 1.66675ZM13.625 12.9751C13.5083 13.1751 13.3 13.2834 13.0833 13.2834C12.975 13.2834 12.8666 13.2584 12.7666 13.1917L10.1833 11.6501C9.54163 11.2667 9.06663 10.4251 9.06663 9.68342V6.26675C9.06663 5.92508 9.34996 5.64175 9.69163 5.64175C10.0333 5.64175 10.3166 5.92508 10.3166 6.26675V9.68342C10.3166 9.98341 10.5666 10.4251 10.825 10.5751L13.4083 12.1167C13.7083 12.2917 13.8083 12.6751 13.625 12.9751Z",
    fill: "#BCBFC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDark);
export default __webpack_public_path__ + "static/media/clock-dark.3eec6f0d05b9e4f4d1cac36c8a5572d2.svg";
export { ForwardRef as ReactComponent };